window.__mcsApi__ = {
    async ready() {
        await import('../initShared');
        await Promise.all([
            await import('./toolkit'),
            await import('./landingsStyles.css'),
            await import('static/css/landings.css'),
        ]);
        const { McsApi } = await import('./api/McsApi');
        const api = new McsApi();
        await api.ready();
        window.__mcsApi__ = api;
        return api;
    },
};
